import React, { createContext, useCallback, useEffect, useMemo, useState } from 'react';

const STORAGE_KEY = 'ftr_compare_ids';

function readStored() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : [];
    } catch {
        return [];
    }
}

export const CompareContext = createContext();

export function CompareProvider({ children }) {
    const [items, setItems] = useState(() => readStored());

    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    }, [items]);

    useEffect(() => {
        const handler = (e) => {
            if (e.key === STORAGE_KEY) setItems(readStored());
        };
        window.addEventListener('storage', handler);
        return () => window.removeEventListener('storage', handler);
    }, []);

    const compareIds = useMemo(() => items.map(i => i.id), [items]);

    const toggleCompare = useCallback((id, name) => {
        setItems(prev => {
            const exists = prev.find(i => i.id === id);
            if (exists) return prev.filter(i => i.id !== id);
            return [...prev, { id, name: name || `#${id}` }];
        });
    }, []);

    const removeCompare = useCallback((id) => {
        setItems(prev => prev.filter(i => i.id !== id));
    }, []);

    const clearCompare = useCallback(() => {
        setItems([]);
    }, []);

    const trekNames = useMemo(() => {
        const names = {};
        items.forEach(i => {
            names[i.id] = i.name;
        });
        return names;
    }, [items]);

    const value = useMemo(() => ({
        items, compareIds, trekNames, toggleCompare, removeCompare, clearCompare,
    }), [items, compareIds, trekNames, toggleCompare, removeCompare, clearCompare]);

    return (
        <CompareContext.Provider value={value}>
            {children}
        </CompareContext.Provider>
    );
}
